import "../dashboard-sections.css";

const PackingProcessingHeader = ({ date, onDateChange, onExport }) => (
  <div className="pp-header">
    <div>
      <h2 className="pp-title">Packing &amp; Processing</h2>
      <p className="pp-subtitle">Daily production summary and facility metrics</p>
    </div>
    {/* <div className="pp-header-actions">
      <div className="pp-date-picker">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/>
          <line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
        </svg>
        <input
          type="date"
          value={date}
          onChange={(e) => onDateChange?.(e.target.value)}
          className="pp-date-input"
        />
      </div>
      <button type="button" className="pp-export-btn" onClick={onExport}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
          <polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
        </svg>
        Export Report
      </button>
    </div> */}
  </div>
);

export default PackingProcessingHeader;
